import React from 'react';
import { Box, TextField, IconButton, Button, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { Question } from '../../../../types/course';

interface OrderEditorProps {
    question: Question;
    onChange: (updatedQuestion: Question) => void;
}

const OrderEditor: React.FC<OrderEditorProps> = ({ question, onChange }) => {
    const items = question.orderItems || [];

    const handleItemChange = (index: number, value: string) => {
        const newItems = [...items];
        newItems[index] = value;
        onChange({ ...question, orderItems: newItems });
    };

    const handleAddItem = () => {
        onChange({ ...question, orderItems: [...items, ''] });
    };

    const handleRemoveItem = (index: number) => {
        const newItems = [...items];
        newItems.splice(index, 1);
        onChange({ ...question, orderItems: newItems });
    };

    const moveItem = (index: number, direction: -1 | 1) => {
        if ((index === 0 && direction === -1) || (index === items.length - 1 && direction === 1)) return;

        const newItems = [...items];
        const temp = newItems[index];
        newItems[index] = newItems[index + direction];
        newItems[index + direction] = temp;
        onChange({ ...question, orderItems: newItems });
    };

    return (
        <Box>
            <Typography variant="subtitle2" gutterBottom>Correct Order (Top to Bottom):</Typography>
            {items.map((item, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', mr: 1 }}>
                        <IconButton
                            size="small"
                            onClick={() => moveItem(index, -1)}
                            disabled={index === 0}
                            sx={{ p: 0.5 }}
                        >
                            <ArrowUpwardIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={() => moveItem(index, 1)}
                            disabled={index === items.length - 1}
                            sx={{ p: 0.5 }}
                        >
                            <ArrowDownwardIcon fontSize="small" />
                        </IconButton>
                    </Box>
                    <TextField
                        fullWidth
                        size="small"
                        placeholder={`Item ${index + 1}`}
                        value={item}
                        onChange={(e) => handleItemChange(index, e.target.value)}
                    />
                    <IconButton
                        size="small"
                        onClick={() => handleRemoveItem(index)}
                        color="error"
                        sx={{ ml: 1 }}
                    >
                        <DeleteIcon fontSize="small" />
                    </IconButton>
                </Box>
            ))}

            <Button
                startIcon={<AddCircleOutlineIcon />}
                onClick={handleAddItem}
                size="small"
                sx={{ mt: 1 }}
            >
                Add Item
            </Button>
        </Box>
    );
};

export default OrderEditor;
